import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UserService } from '../../Dashboard/_services/users.service';
import { AlertService } from '../../Dashboard/_services/alert.service';

// The dashboard exposes revenue and customer data. S-ADMIN and MARKETING open it
// by role; anyone else needs a super admin to have given them the "dashboard"
// page (staff page access). Mirrors the check the server makes in
// OrdersController.getDashboardAnalytics.
export const analyticsGuard = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const userInfo = userService.isLoggedIn();
  const roles = (userInfo.userrole ?? '').split(',');
  const deny = () => {
    alertService.alert('You do not have permission to access this page', 'error');
    return router.createUrlTree(['/sales']);
  };
  if (!userInfo.isLoggedIn) return deny();
  if (roles.includes('S-ADMIN') || roles.includes('MARKETING')) return true;
  return userService.getMyAccess().pipe(
    map((a) => (a?.allowedPages?.includes('dashboard') ? true : deny())),
    catchError(() => of(deny())),
  );
};
